import { withSuspense } from '@lib/common/hoc';
import { lazy } from 'react';

const HoldingDataSearchPage = withSuspense(lazy(() => import('./holding-data-search')));
export default HoldingDataSearchPage;
